import { format, parse, isAfter } from 'date-fns'
import { useQuery } from 'react-query'

import withFetchCancel from '../../../libs/withFetchCancel'
import { useAuthedFetch } from '../../../auth/useAuthedFetch'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

const useAvailableHours = (postalCode, date) => {
  const authedFetch = useAuthedFetch()

  const request = {
    postal_codes: Array.isArray(postalCode) ? postalCode : [postalCode],
    from_date: date,
  }

  const query = useQuery(
    ['pickupAvailableHours', postalCode, date],
    () =>
      withFetchCancel(signal =>
        authedFetch('POST', `${BACKEND_ENDPOINT}/rpc-get-available-hours`, {
          parseJSON: true,
          data: request,
          signal,
        }),
      ),
    {
      enabled:
        postalCode !== '' && postalCode !== null && postalCode !== undefined,
      select: ({ data }) => {
        const pickupOptions = data.find(
          pickupOption => pickupOption.postal_code === postalCode,
        )?.dates

        if (!pickupOptions) return null

        const inTimePickupOptions = pickupOptions.map(pickupOption => {
          const [day, month, year] = pickupOption.pickup_date.split('-')

          return {
            pickup_date: pickupOption.pickup_date,
            pickup_time: pickupOption.pickup_time.filter(pickupTime => {
              const pickupDateTime = new Date(
                `${year}/${month}/${day} ${pickupTime.max_hourminute}`,
              )

              return isAfter(pickupDateTime, new Date())
            }),
          }
        })

        return inTimePickupOptions
          .map(date => {
            const formattedDate = format(
              parse(date.pickup_date, 'dd-M-yyyy', new Date()),
              'yyyy-MM-dd',
            )

            return date.pickup_time.map(d => ({
              minDate: parse(
                d.min_hourminute,
                'HH:mm',
                new Date(formattedDate),
              ),
              maxDate: parse(
                d.max_hourminute,
                'HH:mm',
                new Date(formattedDate),
              ),
            }))
          })
          .filter(x => x.length > 0)
      },
      staleTime: 5 * 60 * 1000,
      useErrorBoundary: false,
    },
  )

  return query
}

export default useAvailableHours
